/* ============================================================
   MIILKs — page interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---- scroll progress bar ---- */
  var progress = document.getElementById('progress');
  function onScroll() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var pct = max > 0 ? (h.scrollTop || document.body.scrollTop) / max : 0;
    progress.style.width = (pct * 100) + '%';
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- fade-up reveals ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- add-to-bag micro feedback ---- */
  document.querySelectorAll('.card-add').forEach(function (btn) {
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (btn.dataset.added) return;
      btn.dataset.added = '1';
      var prev = btn.textContent;
      btn.textContent = prev.trim().length > 1 ? 'Added ✓' : '✓';
      if (btn.classList.contains('btn')) {
        btn.classList.remove('popfx');
        void btn.offsetWidth;
        btn.classList.add('popfx');
      } else {
        btn.style.transform = 'scale(1.06)';
      }
      setTimeout(function () {
        btn.textContent = prev;
        btn.style.transform = '';
        btn.classList.remove('popfx');
        delete btn.dataset.added;
      }, 1200);
    });
  });

  /* ---- "the note nobody owns" stats: count-up + scroll drift ---- */
  var statBox = document.getElementById('statBox');
  if (statBox) {
    var nums = statBox.querySelectorAll('.stat-num');

    function countUp(el, target, dur, delay) {
      setTimeout(function () {
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(eased * target);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = String(target);
        }
        requestAnimationFrame(step);
      }, delay || 0);
    }

    var sObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        nums.forEach(function (n, i) {
          setTimeout(function () { n.classList.add('in'); }, i * 130);
          var t = n.getAttribute('data-count');
          if (t !== null) countUp(n, parseInt(t, 10), 950, i * 130);
        });
        sObs.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    sObs.observe(statBox);

    var driftNums = statBox.querySelectorAll('.stat-num[data-speed]');
    function drift() {
      var vh = window.innerHeight;
      driftNums.forEach(function (n) {
        var r = n.getBoundingClientRect();
        var delta = vh / 2 - (r.top + r.height / 2);
        var sp = parseFloat(n.getAttribute('data-speed')) || 0;
        var ty = Math.max(-22, Math.min(22, delta * sp));
        n.style.transform = 'translateY(' + ty.toFixed(1) + 'px)';
      });
    }
    window.addEventListener('scroll', drift, { passive: true });
    drift();
  }

  /* ---- real-perfumery background video: blob-load to bypass Range reqs ---- */
  var rpVideo = document.getElementById('rpVideo');
  if (rpVideo) {
    var src = rpVideo.getAttribute('data-src');
    var markReady = function () { rpVideo.classList.add('ready'); };
    fetch(src)
      .then(function (r) { return r.ok ? r.blob() : Promise.reject(r.status); })
      .then(function (blob) {
        rpVideo.src = URL.createObjectURL(blob);
        rpVideo.addEventListener('loadeddata', markReady, { once: true });
        var p = rpVideo.play();
        if (p && p.catch) p.catch(function () {});
      })
      .catch(function () {
        // fallback: try direct src (some hosts do support range)
        rpVideo.src = src;
        rpVideo.addEventListener('loadeddata', markReady, { once: true });
        var p2 = rpVideo.play();
        if (p2 && p2.catch) p2.catch(function () {});
      });
  }
})();
